module.exports = __webpack_public_path__ + "fe98e0b129bfa7129ceeaf9f04867238.png";